import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';

export const expand = trigger('expanded', [
  transition('false => true', animate('350ms ease')),
  transition('true => false', animate('350ms ease')),
  state('false', style({ height: '0', visibility: 'hidden' })),
  state('true', style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
]);
